import { useState } from "react";
import Navbar from "@/components/home/Navbar";
import Footer from "@/components/home/Footer";
import CoupDeCoeur from "@/components/montures/CoupDeCoeur";
import MonturesDuMoment from "@/components/montures/MonturesDuMoment";
import StockGrid from "@/components/montures/StockGrid";
import MontureModal from "@/components/montures/MontureModal";

export default function Montures() {
    const [selected, setSelected] = useState(null);

    return (
        <div
            className="min-h-screen font-body bg-lpl-bg text-lpl-text"
            data-testid="montures-page"
        >
            <Navbar />
            <h1 className="sr-only">
                Nos montures · La Petite Lunetterie, opticien à Bourg-en-Bresse
            </h1>
            <main>
                <CoupDeCoeur />
                <MonturesDuMoment onSelect={setSelected} />
                <StockGrid onSelect={setSelected} />
            </main>
            <Footer />
            <MontureModal
                monture={selected}
                onClose={() => setSelected(null)}
            />
        </div>
    );
}
